module.exports = __webpack_public_path__ + "img/silhouette-snow.72915ffe.png";